const DISPLACE = 5;

export function createPin(count, color, isViewed) {
    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46" height="53" viewBox="0 0 46 53">
      <defs>
      ${getFillPath(getSize(count), '')}
      <path undefined="" id="b0" d="M16.268 37.805C7.07 36.481 0 28.565 0 19 0 8.507 8.507 0 19 0s19 8.507 19 19c0 9.566-7.07 17.48-16.268 18.805L19 46l-2.732-8.195z"></path>
        <filter id="a0" width="142.1%" height="134.8%" x="-21.1%" y="-8.7%" filterUnits="objectBoundingBox">
        <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur>
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
        </filter>
      </defs><g fill="none" fill-rule="evenodd" transform="translate(4)"><ellipse cx="19" cy="45.5" fill="#000" fill-opacity=".15" rx="5" ry="1.5"></ellipse><path fill="#000" filter="url(#a0)" id="b0" d="M16.268 37.805C7.07 36.481 0 28.565 0 19 0 8.507 8.507 0 19 0s19 8.507 19 19c0 9.566-7.07 17.48-16.268 18.805L19 46l-2.732-8.195z"></path><path fill="#FFF" id="b0" d="M16.268 37.805C7.07 36.481 0 28.565 0 19 0 8.507 8.507 0 19 0s19 8.507 19 19c0 9.566-7.07 17.48-16.268 18.805L19 46l-2.732-8.195z"></path></g>
      <path fill="none" stroke="${color}" ${isViewed ? 'opacity=".5"' : ''} stroke-width="4" d="M 23 19 m -15 0 a 15 15 0 1 1 30 0 a 15 15 0 1 1 -30 0"></path>
      <text x="23" y="24" ${isViewed ? 'opacity=".5"' : ''} font-family="Lato" font-size="14" font-weight="900" text-anchor="middle">
        ${count}
      </text>
  </svg>`;
}

export function createMultiPin(stats, count, isViewed) {
    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="54" height="61" viewBox="0 0 54 61">
  <defs>
  ${getFillPath(getSize(count), '')}
  <filter id="a1" width="134.8%" height="129.6%" x="-17.4%" y="-7.4%" filterUnits="objectBoundingBox">
      <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
  <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur>
  <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>

  </filter>
  <path id="d" d="M39.774 16.457C37.156 9.751 30.633 5 23 5 15.616 5 9.271 9.446 6.495 15.806"></path>
  <path id="e" d="M18.8 40.507c1.347.322 2.754.493 4.2.493 9.941 0 18-8.059 18-18 0-2.057-.345-4.034-.98-5.875"></path>

  </defs><g fill="none" fill-rule="evenodd" transform="translate(4)"><ellipse cx="23" cy="53.5" fill="#000" fill-opacity=".15" rx="5" ry="1.5"></ellipse>
  <path fill="#000" filter="url(#a1)" id="b1" d="M20.28 45.84C8.86 44.496 0 34.783 0 23 0 10.297 10.297 0 23 0s23 10.297 23 23c0 11.782-8.86 21.495-20.28 22.84L23 54l-2.72-8.16z"></path>
  <path fill="#FFF" id="b1" d="M20.28 45.84C8.86 44.496 0 34.783 0 23 0 10.297 10.297 0 23 0s23 10.297 23 23c0 11.782-8.86 21.495-20.28 22.84L23 54l-2.72-8.16z"></path></g>

  <g ${isViewed ? 'opacity=".5"' : ''} >
    ${calcArcs(stats, count)}
    <text x="27" y="28" font-family="Lato" font-size="14" font-weight="900" text-anchor="middle">
      ${count}
    </text>
  </g>
</svg>`;
}

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180;

    return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians)),
    };
}

export function getCircleDescribe(x, y, r) {
    return [
        'M', x, y,
        'm', -r, 0,
        'a', r, r, 0, 1, 1, (r * 2), 0,
        'a', r, r, 0, 1, 1, -(r * 2), 0,
    ].join(' ');
}

export function getArcDescribe(x,  y,  r,  startAngle,  endAngle) {

    if (startAngle === 0 && endAngle === 360) {
        return getCircleDescribe(x, y, r);
    }

    const start = polarToCartesian(x, y, r, endAngle);
    const end = polarToCartesian(x, y, r, startAngle);

    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

    return [
        'M', start.x, start.y,
        'A', r, r, 0, largeArcFlag, 0, end.x, end.y,
    ].join(' ');
}

function getSizeGeometryForArc(size) {
    switch (size) {
        case 'small':
            return {
                r: 15,
                x: 23,
                y: 19,
            };
        case 'medium':
            return {
                r: 18,
                x: 27,
                y: 23,
            };
        case 'large':
            return {
                r: 24,
                x: 33,
                y: 29,
            };
        default:
            return {
                r: 15,
                x: 23,
                y: 19,
            };
    }
}

function getSize(count) {
    if (count < 2) { return 'small'; }
    if (count < 1000) { return 'medium'; }
    if (count < 10000) { return 'large'; }

    return 'large';
}

function calcArcs(stats, totalItems) {
    const geometry = getSizeGeometryForArc('medium');

    return stats.reduce((acc, item, index) => {
        const arcPosition = getArcPosition(totalItems, index, item.count);

        return {
            prevPos: acc.prevPos + arcPosition,
            value: acc.value + `<path fill="none" stroke="${item.color}" stroke-width="4" d="${getArcDescribe(geometry.x, geometry.y, geometry.r, acc.prevPos, acc.prevPos + arcPosition - DISPLACE)}"></path>`,
        };
    }, {prevPos: 0, value: ''}).value;
}

function getArcPosition(total, arcPosition, count) {
    return (360 * count) / total;
}

export function getFillPath(size, attrs) {
    switch (size) {
        case 'small':
            return `<path ${attrs} id="b0" d="M16.268 37.805C7.07 36.481 0 28.565 0 19 0 8.507 8.507 0 19 0s19 8.507 19 19c0 9.566-7.07 17.48-16.268 18.805L19 46l-2.732-8.195z"/>`;

        case 'medium':
            return `<path ${attrs} id="b1" d="M20.28 45.84C8.86 44.496 0 34.783 0 23 0 10.297 10.297 0 23 0s23 10.297 23 23c0 11.782-8.86 21.495-20.28 22.84L23 54l-2.72-8.16z"/>`;

        case 'large':
            return `<path ${attrs} id="b2" d="M26.292 57.875C11.545 56.51 0 44.103 0 29 0 12.984 12.984 0 29 0s29 12.984 29 29c0 15.103-11.545 27.51-26.292 28.875L29 66l-2.708-8.125z"/>`;

        default:
            return '';
    }
}

export function getSimilarPin(point, isViewed) {
    if (point.stat.length === 1) {
        return createPin(point.stat[0].count, point.stat[0].color, isViewed);
    } else {
        return createMultiPin(point.stat, point.content.offers_count, isViewed);
    }
}

export const IconCurrentOffer = `<svg xmlns="http://www.w3.org/2000/svg" width="62" height="69" viewBox="0 0 62 69">
  <defs>
      <path id="current-offer-svg-a" d="M20.28 45.84C8.86 44.496 0 34.783 0 23 0 10.297 10.297 0 23 0s23 10.297 23 23c0 11.782-8.86 21.495-20.28 22.84L23 54l-2.72-8.16z"/>
      <filter id="current-offer-svg-b" width="169.6%" height="159.3%" x="-34.8%" y="-14.8%" filterUnits="objectBoundingBox">
          <feOffset dy="8" in="SourceAlpha" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4"/>
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      </filter>
  </defs>
  <g fill="none" fillRule="evenodd" transform="translate(8)">
      <ellipse cx="23" cy="53.5" fill="#000" fill-opacity=".15" rx="5" ry="1.5"/>
      <mask id="current-offer-svg-c" fill="#fff">
          <use xlink:href="#current-offer-svg-a"/>
      </mask>
      <use fill="#000" filter="url(#current-offer-svg-b)" xlink:href="#current-offer-svg-a"/>
      <use fill="#FFF" xlink:href="#current-offer-svg-a"/>
      <path class="cian-map-pin-element" d="M23 43c11.046 0 20-8.954 20-20S34.046 3 23 3 3 11.954 3 23s8.954 20 20 20z" mask="url(#current-offer-svg-c)"/>
      <path fill="#FFF" d="M28.67 23.2v-4.94h-2.744v2.42L23 18l-8 7.34L17.897 28 23 23.307 28.103 28 31 25.34z" mask="url(#current-offer-svg-c)"/>
  </g>
</svg>
<style>
    .cian-map-pin-element {
        fill: #2B87DB;
    }
</style>
`;

export const MEDICINE_ICON = `<div style="border-radius: 50%;width: 24px; height: 24px; display: flex;justify-content: center;align-items: center;color: white; box-sizing: border-box; margin: -12px -12px">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
        <circle cx="14" cy="14" r="12" fill="#4ACC67"/>
        <circle cx="14" cy="14" r="11" stroke="white" stroke-width="2"/>
        </g>
        <path d="M19.25 11.75H16.25V8.75C16.25 8.3 15.95 8 15.5 8H12.5C12.05 8 11.75 8.3 11.75 8.75V11.75H8.75C8.3 11.75 8 12.05 8 12.5V15.5C8 15.95 8.3 16.25 8.75 16.25H11.75V19.25C11.75 19.7 12.05 20 12.5 20H15.5C15.95 20 16.25 19.7 16.25 19.25V16.25H19.25C19.7 16.25 20 15.95 20 15.5V12.5C20 12.05 19.7 11.75 19.25 11.75Z" fill="white"/>
        <defs>
        <filter id="filter0_d" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        </defs>
    </svg>
  </div>`;
export const SCHOOL_ICON = `<div style="border-radius: 50%;width: 24px; height: 24px; display: flex;justify-content: center;align-items: center;color: white; box-sizing: border-box; margin: -12px -12px">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
        <circle cx="14" cy="14" r="12" fill="#2B87DB"/>
        <circle cx="14" cy="14" r="11" stroke="white" stroke-width="2"/>
        </g>
        <path d="M13.25 9.91699V20L8.45 17.861C8.15 17.785 8 17.48 8 17.174V8.76999C8 8.53999 8.15 8.31199 8.3 8.15999C8.525 8.00699 8.825 7.92999 9.05 8.08299L13.25 9.91699ZM19.7 8.15999C19.85 8.31199 20 8.54199 20 8.76999V17.25C20 17.556 19.85 17.785 19.55 17.937L14.75 20V9.91699L19.025 8.08299C19.25 8.00699 19.475 8.00699 19.7 8.15999Z" fill="white"/>
        <defs>
        <filter id="filter0_d" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        </defs>
    </svg>
  </div>`;
export const KINDERGARDEN_ICON = `<div style="border-radius: 50%;width: 24px; height: 24px; display: flex;justify-content: center;align-items: center;color: white; box-sizing: border-box; margin: -12px -12px">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d)">
            <circle cx="14" cy="14" r="12" fill="#4AD3E3"/>
            <circle cx="14" cy="14" r="11" stroke="white" stroke-width="2"/>
            </g>
            <path d="M17.9571 13.3223C18.5307 13.3223 19 13.7663 19 14.3086C19 14.8509 18.5307 15.295 17.9443 15.295H16.2236C16.2371 15.3685 16.2371 15.43 16.2371 15.505V16.5153C16.2371 16.6263 16.2236 16.7494 16.2107 16.8731L18.0486 18.0072C18.4786 18.4633 18.4786 19.1413 18.0486 19.5974C17.5786 20.0902 16.77 20.1397 16.2486 19.6956L15.3757 18.8706C14.929 19.1077 14.4355 19.2312 13.935 19.2312C13.4345 19.2312 12.941 19.1077 12.4943 18.8706L11.6207 19.6956C11.1514 20.0902 10.4343 20.0902 9.95143 19.6956C9.43 19.2651 9.37857 18.5 9.83429 18.0072L11.685 16.8484C11.6693 16.7298 11.6604 16.6103 11.6586 16.4906V15.4795C11.6586 15.406 11.6721 15.3317 11.6721 15.2695H10.0429C9.46857 15.2702 9 14.8277 9 14.2846C9 13.7423 9.46929 13.2983 10.0429 13.2983H11.5814C11.6729 13.2983 11.7507 13.311 11.8421 13.3358C11.19 12.768 10.8121 11.9789 10.8121 11.1411C10.8121 10.9933 10.825 10.8328 10.8514 10.685C10.6066 10.6014 10.3866 10.4525 10.2129 10.253C9.70429 9.66195 9.80857 8.78662 10.4343 8.30583C11.06 7.82503 11.9857 7.92329 12.4943 8.51509C12.9488 8.28988 13.4452 8.17308 13.9479 8.17308C14.4505 8.17308 14.9469 8.28988 15.4014 8.51509C15.5707 8.31783 15.7929 8.17006 16.0407 8.0838C16.81 7.82503 17.6443 8.19481 17.9307 8.92163C18.205 9.6492 17.8136 10.4503 17.0571 10.7098C17.2271 11.7201 16.8357 12.744 16.0143 13.4093C16.146 13.3499 16.2881 13.3205 16.4314 13.323H17.9571V13.3223ZM15.9357 8.80987L16.0407 8.93363C16.275 9.11815 16.4707 9.34017 16.6271 9.58619L16.9529 9.94473C17.0294 9.88593 17.0932 9.8107 17.1399 9.72404C17.1866 9.63738 17.2153 9.54127 17.2239 9.4421C17.2326 9.34292 17.221 9.24295 17.1901 9.14881C17.1591 9.05468 17.1094 8.96855 17.0443 8.89613C16.7707 8.5886 16.275 8.5511 15.9364 8.80987H15.9357ZM13.2643 12.3607C13.1857 12.2864 13.0686 12.2864 13.0036 12.3607C12.9379 12.435 12.9379 12.546 13.0164 12.6075C13.5379 13.1003 14.385 13.1003 14.9071 12.6075C14.9857 12.5332 14.9857 12.435 14.9071 12.3607C14.8722 12.3251 14.8255 12.3052 14.7768 12.3052C14.7281 12.3052 14.6814 12.3251 14.6464 12.3607C14.5029 12.4837 14.3329 12.5707 14.1379 12.6075V11.8919C14.4764 11.6579 14.4636 11.3744 14.4636 11.3744C14.4636 11.2266 14.3464 11.1156 14.19 11.1036H13.7207C13.6857 11.1022 13.6508 11.1081 13.618 11.121C13.5852 11.1339 13.5551 11.1535 13.5296 11.1787C13.5041 11.2039 13.4836 11.2342 13.4693 11.2678C13.455 11.3014 13.4473 11.3376 13.4464 11.3744C13.46 11.5844 13.5771 11.7809 13.7729 11.8919V12.6075C13.5859 12.5726 13.4107 12.4876 13.2643 12.3607ZM10.9557 9.95673L11.2686 9.59895C11.4379 9.35292 11.6336 9.1309 11.855 8.94638L11.9729 8.82262C11.6464 8.5511 11.1514 8.6006 10.8643 8.90888C10.7965 8.97979 10.7444 9.06553 10.7118 9.15999C10.6792 9.25445 10.6668 9.3553 10.6755 9.45537C10.6842 9.55543 10.7139 9.65224 10.7623 9.7389C10.8107 9.82556 10.8768 9.89994 10.9557 9.95673ZM12.4379 10.9993C12.61 10.9993 12.75 10.8643 12.75 10.6993C12.75 10.5343 12.61 10.3993 12.4371 10.3993C12.265 10.3993 12.125 10.5343 12.125 10.6993C12.125 10.8643 12.265 10.9993 12.4379 10.9993ZM15.5629 10.9993C15.735 10.9993 15.875 10.8643 15.875 10.6993C15.875 10.5343 15.735 10.3993 15.5621 10.3993C15.39 10.3993 15.25 10.5343 15.25 10.6993C15.25 10.8643 15.39 10.9993 15.5629 10.9993Z" fill="white"/>
            <defs>
            <filter id="filter0_d" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset/>
            <feGaussianBlur stdDeviation="1"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
            </defs>
        </svg>
    </div>`;
export const LEBENSMITTELGESCHEFT_ICON = `<div style="border-radius: 50%;width: 24px; height: 24px; display: flex;justify-content: center;align-items: center;color: white; box-sizing: border-box; margin: -12px -12px">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
        <circle cx="14" cy="14" r="12" fill="#FF9900"/>
        <circle cx="14" cy="14" r="11" stroke="white" stroke-width="2"/>
        </g>
        <path d="M19.278 10.25C19.88 10.25 20.105 10.85 19.955 11.225L18.451 15.725C18.409 15.8733 18.3206 16.0043 18.1988 16.0988C18.077 16.1932 17.9281 16.2462 17.774 16.25H11.76C11.384 16.25 11.084 16.025 11.009 15.65L9.654 9.5H8V8H10.256C10.632 8 10.932 8.225 11.008 8.6L11.383 10.25H19.278ZM11.76 20C10.93 20 10.257 19.328 10.257 18.5C10.257 17.672 10.929 17 11.759 17C12.589 17 13.263 17.672 13.263 18.5C13.263 19.328 12.59 20 11.76 20ZM17.775 20C16.945 20 16.272 19.328 16.272 18.5C16.272 17.672 16.944 17 17.774 17C18.604 17 19.278 17.672 19.278 18.5C19.278 19.328 18.605 20 17.774 20H17.775Z" fill="white"/>
        <defs>
        <filter id="filter0_d" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        </defs>
    </svg>
    </div>`;

export function createIcon(offerPosition, id, icon, zIndex) {
    return {
        geometry: {
            coordinates: offerPosition,
            type: 'Point',
        },
        id,
        options: {
            iconLayout: window.ymaps.templateLayoutFactory.createClass(icon),
            iconOffset: [-27, -61],
            iconShape: {
                coordinates: [27, 27],
                radius: 26.5,
                type: 'Circle',
            },
            iconSize: [54, 61],
            zIndex,
        },
        type: 'Feature',
    };
}
export function createInfrastructureIcon(offerPosition, id, icon, zIndex) {
    return {
        geometry: {
            coordinates: offerPosition,
            type: 'Point',
        },
        id,
        options: {
            iconLayout: window.ymaps.templateLayoutFactory.createClass(icon),
            iconShape: {
                coordinates: [0, 0],
                radius: 12,
                type: 'Circle',
            },
            iconSize: [24, 24],
            zIndex,
        },
        type: 'Feature',
    };
}
